import {
  RESET_STAR_OBJ,
  RESET_STAR_STATUS,
  STAR_MSG_ERROR,
  STAR_MSG,
  STARRED_MSG,
} from "./actionTypes";

export const resetStarObj = () => {
  return {
    type: RESET_STAR_OBJ,
    payload: {},
  };
};
export const resetStarStatus = (reset) => {
  return {
    type: RESET_STAR_STATUS,
    payload: reset,
  };
};
export const starMsgError = (error) => {
  return {
    type: STAR_MSG_ERROR,
    payload: error,
  };
};

export const starMsg = (chatId, msgId, starred) => {
  return {
    type: STAR_MSG,
    payload: { chatId, msgId, starred },
  };
};
export const starredMsg = (data) => {
  return {
    type: STARRED_MSG,
    payload: data,
  };
};
